export const RESNET_IMAGE_URLS = [
  {text: 'cat', value: require('@/assets/ResNetSampleImages/cat.jpg')},
  {text: 'dog', value: require('@/assets/ResNetSampleImages/dog.jpg')},
  {text: 'flower', value: require('@/assets/ResNetSampleImages/flower.jpg')},
  {text: 'bike', value: require('@/assets/ResNetSampleImages/bike.jpg')},
  {text: 'human', value: require('@/assets/ResNetSampleImages/human.png')},
  {text: 'car', value: require('@/assets/ResNetSampleImages/car.jpg')},
  {text: 'horse', value: require('@/assets/ResNetSampleImages/horse.jpg')},
];